import React from 'react';
import { cryptoScannerContent } from '../rich-content/crypto-scanner-complete-content';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';

const CryptoScannerDetailPage = () => {
  return <AutomaticPageBuilder content={cryptoScannerContent} />;
};

export default CryptoScannerDetailPage;
